import api from "./api";

const TOKEN_KEY = "pm_token";
const ADMIN_KEY = "pm_admin_account";

const adminAuthService = {
  login: (payload) => api.post("/admin-auth/login", payload).then((r) => r.data),
  me: () => api.get("/admin-auth/me").then((r) => r.data),

  saveSession: ({ token, admin }) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
  },
  getToken: () => localStorage.getItem(TOKEN_KEY),
  getAdmin: () => {
    try {
      return JSON.parse(localStorage.getItem(ADMIN_KEY) || "null");
    } catch {
      return null;
    }
  },
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ADMIN_KEY);
  },
};

export default adminAuthService;
